import React from 'react';
import './QuickFiltersBar.css';
import { PricingStatsResponse } from 'types/interfaces/admin/cardPricing';

interface FilterOption {
  key: string;
  label: string;
  count?: number;
  color?: string;
}

interface QuickFiltersBarProps {
  currentFilter: string;
  onFilterChange: (filter: string) => void;
  stats?: PricingStatsResponse;
}

const QuickFiltersBar: React.FC<QuickFiltersBarProps> = ({
  currentFilter,
  onFilterChange,
  stats,
}) => {
  const filters: FilterOption[] = [
    {
      key: 'incomplete',
      label: 'Incomplete',
      count: stats?.cardsWithIncompletePricing,
    },
    {
      key: 'missingAll',
      label: 'Missing All',
      count: stats?.cardsMissingNonfoil,
      color: '#ef4444',
    },
    {
      key: 'missingFoil',
      label: 'Missing Foil',
      count: stats?.cardsMissingFoil,
      color: '#f59e0b',
    },
    {
      key: 'manualOverrides',
      label: 'Manual Overrides',
      count: stats?.cardsWithManualOverride,
      color: '#8b5cf6',
    },
  ];

  return (
    <div className="quick-filters-bar">
      {filters.map((filter) => (
        <button
          key={filter.key}
          className={`filter-chip ${currentFilter === filter.key ? 'active' : ''}`}
          onClick={() => onFilterChange(filter.key)}
          style={
            filter.color && currentFilter === filter.key
              ? { borderColor: filter.color, backgroundColor: `${filter.color}20` }
              : undefined
          }
        >
          <span className="filter-label">{filter.label}</span>
          {filter.count !== undefined && (
            <span className="filter-count">({filter.count.toLocaleString()})</span>
          )}
        </button>
      ))}
    </div>
  );
};

export default QuickFiltersBar;
